import React, { Component } from 'react';
import { Col, Layout, Row } from 'antd';
import img from '../assets/img/At the office-pana 1.png';
const { Content } = Layout;
class About extends Component {
    render() {
        return (
            <Content>
                <div className="mi_main_div">
                <div className="mi_main1">
                    <div className="mi_box">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">About Us</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px'}} src={img} />
                            </Col>
                        </Row>
                    </div></div>
                    <div className="mi_main">
                        <h4> MiComp Solutions provides configurable capabilities to effectively manage all your distribution channels, including:</h4>
                        <p> Compliance, Onboarding, Management, Calculation and Payment of Commission & Bonus,
                        and an array of administrative support tools & reporting for Insurers, Brokers and Agencies.</p>
                        <p><b >MiComp On Boarding:</b></p>
                        <p>Identifying the right distribution channel for your product offerings and onboarding the agencies and brokers, while maintaining all compliance needs, is a time consuming and a rigorous process. Its Provides</p>
                        <ul>
                            <li><p>Automated process to invite and accept Agencies / Brokers / FMOs, etc.</p></li>
                            <li><p>Add and maintain distribution information and establish hierarchy</p></li>
                            <li><p>Complete set-up of New Distribution Partners</p></li>
                            <li><p>Transfer file of Existing Distribution Partners</p></li>
                            <li><p>Validation of Current and Ongoing Licensure</p></li>
                            <li><p>Workflow process to upload, review and approve documents such as Licenses, Certificates, etc.</p></li>
                            <li><p>Manage all Agreements</p></li>
                            <li><p>Manage regular Communications with the Distribution</p></li>
                            <li><p>Extensive reporting and decision support processes</p></li>
                        </ul>
                        <p ><b > MiComp Commission:</b></p>
                        <p>MiComp Commission is a comprehensive commission and bonus management product that allows automated reconciliation; and forecasting based on past data using future assumptions. It Provides</p>
                        <ul><li>
                            <p>Assessment of Current Compensation Programs to identify potential Discrepancies</p>
                        </li>
                            <li>
                                <p>Commission consultation to provide forecast and budgeting based on past data
</p>
                            </li>
                            <li>
                                <p>Customize Carrier Specific Compensation programs for Commission and Bonus</p>
                            </li>
                            <li>
                                <p>A modular rules engine to manage commission / bonus arrangements and rules</p>
                            </li>
                            <li>
                                <p>On time commission / bonus calculation for each approved distribution channel</p>
                            </li>
                            <li>
                                <p>Year to date Commission and Bonus reconciliation</p>
                            </li></ul>
                    </div>
                </div></Content>
        )
    }
}
export default About;
